export const GOOGLE_SCOPE_PICKER = 'https://www.googleapis.com/auth/photospicker.mediaitems.readonly';
export const GOOGLE_SCOPE_YOUTUBE = 'https://www.googleapis.com/auth/youtube.upload';
export const MAX_TOKEN_TIME: Milliseconds = 50 * 60 * 1000; // 50min
